import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { User } from 'src/app/models/users/user.model';
import { AccountService } from '../account/account.service';
import { AthleteService } from '../athlete/athlete.service';
import { AuthorityVerificationService } from '../authority-verification/authority-verification.service';
import { ManagerService } from '../manager/manager.service';

@Injectable({
  providedIn: 'root',
})
export class PrincipalService {
  constructor(
    private accountService: AccountService,
    private managerService: ManagerService,
    private athleteService: AthleteService,
    private authorityVerificationService: AuthorityVerificationService,
  ) {}

  async identity(): Promise<User> {
    const account = await firstValueFrom(this.accountService.get());
    if (account.id) {
      account.athlete = await firstValueFrom(this.athleteService.getAthlete(account.id));
      if (
        this.authorityVerificationService.hasTestingManagerRole(account) ||
        this.authorityVerificationService.hasS2ALocalRole(account)
      ) {
        account.manager = await firstValueFrom(this.managerService.getManager(account.id));
      }
    }
    return account;
  }
}
